import { gql } from '@apollo/client';

export const UPDATE_NEWS_STATUS_BY_ID = gql`
  mutation updateNewsStatusById($newsItemId: String!, $istGelesen: Boolean!) {
    navigation_updateNewsItem(
      newsItemId: $newsItemId
      istGelesen: $istGelesen
    ) {
      ... on navigation_NewsUpdateMutationResponse {
        newsItem {
          id
          titel
          inhalt
          istGelesen
          veroeffentlichtAm
          bildUrl
        }
        error {
          message
        }
      }
    }
  }
`;
